import { useTranslation } from 'react-i18next';
import { Container, Panel, AppInfoContainer } from './Register.style';
import backgroundImage from '../../assets/images/air_traffic_control_tower_sunset_small.png';
import RegisterPanel from './registerPanel/RegisterPanel';

const Register = () => {
  const { t } = useTranslation();

  return (
    <Container backgroundImage={backgroundImage}>
      <Panel>
        <AppInfoContainer>
            <h2><span style={{fontWeight:300}}>BHANSA</span> <span>RASPORED</span></h2>
        </AppInfoContainer>
        <RegisterPanel app="App" />
      </Panel>
    </Container>
  );
};

export default Register; 